<div class="dsg-selection" [ngStyle]="boxStyles()" [class.is-multiple]="multiple()">
  <button
    *ngIf="multiple() && !interacting()"
    type="button"
    class="dsg-group-action"
    (pointerdown)="$event.stopPropagation()"
    (click)="onGroupClick($event)"
    aria-label="Group selected components"
  >
    <span class="dsg-group-action-icon" aria-hidden="true">&#9638;</span>
    Group {{ selectionCount() }} items
  </button>

  <span *ngIf="grouped() && !interacting()" class="dsg-group-badge">Group</span>

  <!-- Rotate grip sits above the top edge, outside the box. -->
  <button
    *ngIf="showHandles()"
    type="button"
    class="dsg-rotate-grip"
    (pointerdown)="onRotatePointerDown($event)"
    aria-label="Rotate"
  ></button>

  <span
    *ngFor="let handle of handles"
    class="dsg-handle"
    [class]="'dsg-handle dsg-handle-' + handle"
    [hidden]="!showHandles()"
    [ngStyle]="handleStyles(handle)"
    (pointerdown)="onHandlePointerDown(handle, $event)"
  ></span>

  <span class="dsg-selection-label">{{ label() }}</span>
</div>
